import { type ChatMessage, type ChatMessageWithMetadata } from "@fitness-app/data-models/entities/Chat";

type MessageUpdate = Partial<ChatMessageWithMetadata | ChatMessage> & { id: string };

/**
 * Applies a partial realtime update to the message the store holds. One level deeper than a
 * spread for `extra`: a reaction or edit is broadcast with `extra: { version: 2 }` alone, and
 * a flat merge would wipe the link cards chat-service stored there (TRE-2174).
 */
export const mergeMessageUpdate = (message: ChatMessage, update: MessageUpdate): ChatMessage => {
  const merged = { ...message, ...update } as ChatMessage;

  if (message.extra && update.extra) {
    merged.extra = { ...message.extra, ...update.extra };
  }

  return merged;
};
